import messages from '../../../locale/jsonMessages';

const validate = values => {
  const errors = {};
  if (!values.recommendOrder || values.recommendOrder.toString().trim() === '' || isNaN(values.recommendOrder) || values.recommendOrder <= 0) errors.recommendOrder = messages.required;
  if (!values.placesOrder || values.placesOrder.toString().trim() === '' || isNaN(values.placesOrder) || values.placesOrder <= 0) errors.placesOrder = messages.required;
  if (!values.bannerOrder || values.bannerOrder.toString().trim() === '' || isNaN(values.bannerOrder) || values.bannerOrder <= 0) errors.bannerOrder = messages.required;
  if (!values.mostViewedOrder || values.mostViewedOrder.toString().trim() === '' || isNaN(values.mostViewedOrder) || values.mostViewedOrder <= 0) errors.mostViewedOrder = messages.required;
  return errors;
}

export default validate;
